__turbopack_context__.v({
  "chip": "Chip-module__ZxBdLG__chip",
});
